import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  id: "pdf"
}
const _hoisted_4 = {
  key: 0,
  class: "img"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    isDisabled: _ctx.isDisabled,
    current: 2,
    btnText: '确认',
    prePathName: _ctx.isPiVerify ? 'statement' : 'pi'
  }, {
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "所有开户文件", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "file-item",
          key: index,
          onClick: ($event: any) => (_ctx.toFile(item.name, item.text))
        }, [
          (item.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(item.text), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(item.text), 1)),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "iconfont icon-you" }, null, -1))
        ], 8, _hoisted_1))
      }), 128)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "请您手写签名", -1)),
      _createElementVNode("div", {
        class: "signature",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signatureHandle && _ctx.signatureHandle(...args)))
      }, [
        (_ctx.signImageUrl)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.signImageUrl,
                alt: ""
              }, null, 8, _hoisted_5)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, "点击进行签名"))
      ]),
      _createVNode(_component_van_field, { rules: [{ required: true, message: '请同意开户文件协议' }] }, {
        input: _withCtx(() => [
          _createVNode(_component_van_checkbox, {
            shape: "square",
            modelValue: _ctx.agreeOpenFile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agreeOpenFile) = $event)),
            onChange: _ctx.changeAgree
          }, {
            icon: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(
                `iconfont ${_ctx.agreeOpenFile ? 'icon-duoxuanxuanzhong' : 'icon-duoxuanweixuanzhong'}`
              )
              }, null, 2)
            ]),
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createTextVNode(" 我已阅读并同意以上开户文件，了解相关风险并愿意在金马开户"))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled", "prePathName"]))
}